import { createFileRoute } from '@tanstack/react-router';
import { Section } from '@cartcloser/ui/marketing';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <Section title="Privacy Policy">
      <div className="mx-auto max-w-2xl space-y-4 text-sm text-muted-foreground">
        <p>
          This is a placeholder privacy policy. CartCloser processes shopper conversations and
          merchant catalogue data solely to provide the service.
        </p>
        <p>
          We do not sell personal data. Conversation transcripts and analytics are available to the
          merchant that owns them. Replace this page with your finalised policy before launch.
        </p>
      </div>
    </Section>
  );
}
